// React
import React, {Component} from 'react';
// Translations
import { withTranslation } from 'react-i18next';
// Styles
import './styles.scss';
// Components
import {ProfileSidebar} from '../../Sidebars';
// IMG
import user_png from "@img/user.png";

class ProfileCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hoverText: false,
            open: false
        }
    }

    changeText = () => {
        var str = this.state.hoverText ? false : this.props.t(`commons:profile.card.hover`);
        this.setState({hoverText: str});
    }

    userFirstName = () => {
        const {user, t} = this.props;

        var str = user?.first_name ? `, ${user.first_name}` : '';

        return `${t('commons:profile.card.welcome', {name: str})}`
    }

    render() {
        const {user, plan} = this.props;
        const {hoverText, open} = this.state;
        return (
            <React.Fragment>
                <div id={"commons_profile"} className="profile platform_profile_card" onMouseEnter={this.changeText}
                     onMouseLeave={this.changeText} onClick={() => this.setState({open: !open})}>
                    <span>{hoverText ? hoverText : this.userFirstName()}</span>
                    <img alt="platform_user" src={user_png}/>
                </div>
                <ProfileSidebar user={user} plan={plan} open={open} handleMenuToggle={() => this.setState({open: !open})}
                                title={this.userFirstName()}/>
            </React.Fragment>
        );
    }
}

export default withTranslation()(ProfileCard);